// Copyright 2026. WebPros International GmbH. All rights reserved.

export const FAILOVER_DOMAINS = {
    TABLE: 'failover-domains-table',
};

export const FAILOVER_DOMAIN = {
    IS_ACTIVE: 'is-active',
    DELETE: 'delete',
    EDIT: 'edit',
    CREATE_DIALOG: 'failover-domain-create-dialog',
    DIALOG_CLOSE: 'failover-domain-dialog-close',
    NAME: 'failover-domain-name',
    DESCRIPTION: 'failover-domain-description',
    STORAGE: 'failover-domain-storage',
    LOCATION: 'failover-domain-location',
    NEXT_BTN: 'failover-domain-next-btn',
    BACK_BTN: 'failover-domain-back-btn',
    SUBMIT_BTN: 'failover-domain-submit-btn',
    SEARCH: 'failover-domain-search',
    CR_STEP: 'failover-domain-cr-step',
    CR_SELECT_ALL: 'failover-domain-cr-select-all',
    CR_LOAD_MORE: 'failover-domain-cr-load-more',
    CR_PROMOTION_NOTICE: 'failover-domain-cr-promotion-notice',
    IP_STEP: 'failover-domain-ip-step',
    STEP_BREADCRUMB: 'failover-domain-step-breadcrumb',
    STEP_CR: 'failover-domain-step-cr',
    STEP_IP: 'failover-domain-step-ip',
};

// Per-id data-cy base keys, used with dataCySelector(id, KEY) -> `${id}-${key}`.
export const FAILOVER_DOMAIN_ROW = {
    CR_ADD: 'failover-domain-cr-add',
    CR_REMOVE: 'failover-domain-cr-remove',
    CR_ROW: 'failover-domain-cr-row',
    IP_ADD: 'failover-domain-ip-add',
    IP_REMOVE: 'failover-domain-ip-remove',
    IP_ROW: 'failover-domain-ip-row',
};
